import { render, staticRenderFns } from "./star-chart.vue?vue&type=template&id=9a8180a8&"
import script from "./star-chart.vue?vue&type=script&lang=js&"
export * from "./star-chart.vue?vue&type=script&lang=js&"
import style0 from "./star-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports